'use client';
import Link from 'next/link';
import { lazy, Suspense, useState } from 'react';
const TirageTable = lazy(() => import('./TirageTable'));

const NextGames = ({ model }) => {
  const half = Math.ceil(model?.tirages.length / 2);
  const firstHalfTirages = model?.tirages.slice(0, half);
  const secondHalfTirages = model?.tirages.slice(half);
  // Initialize the state to save currently opened accordion
  const [openedAccordion, setOpenedAccordion] = useState(null);

  // `handleToggle` toggles the accordion and closes the other one, and updates the render status of TirageTables
  const handleToggle = (id) => {
    if (openedAccordion !== id) {
      setOpenedAccordion(id);
    } else {
      setOpenedAccordion(null);
    }
  };

  const renderTirages = (tirages, parentId) => (
    <div className="accordion" id={parentId}>
      {tirages?.map((tirage, index) => (
        <div className="accordion-item" key={tirage.id}>
          <h2 className="accordion-header" id={`heading-${parentId}-${index}`}>
            <button
              onClick={() => handleToggle(`collapse-${parentId}-${index}`)}
              className={`accordion-button ${openedAccordion === `collapse-${parentId}-${index}` ? '' : 'collapsed'
                }`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${parentId}-${index}`}
              aria-expanded={openedAccordion === `collapse-${parentId}-${index}`}
              aria-controls={`collapse-${parentId}-${index}`}
            >
              {tirage.dateOuvertureString.toLowerCase()}
              &nbsp;
              <span className="text-dark fw-bold">{tirage.description}</span>
            </button>
          </h2>
          <div
            id={`collapse-${parentId}-${index}`}
            className={`accordion-collapse ${openedAccordion === `collapse-${parentId}-${index}` ? 'show' : 'collapse'
              }`}
            aria-labelledby={`heading-${parentId}-${index}`}
          >
            <div className="accordion-body">
              <Suspense fallback={<div>Loading...</div>}>
                <TirageTable tirage={tirage} model={model} />
              </Suspense>
              <div className={'mt-2'}>
                <Link href={`/achats?tirageId=${tirage.id}`} passHref className={'btn btn-sales'}>
                  Acheter des cartes
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <div className="row">
        <div className="col-12 col-lg-6">{renderTirages(firstHalfTirages, 'nextGames1')}</div>
        <div className="col-12 col-lg-6">{renderTirages(secondHalfTirages, 'nextGames2')}</div>
      </div>
    </>
  );
};

export default NextGames;
